/* ===========================================================================
   ROVE NEXT - PDP delivery estimate, 25 August 2026.

   The buy box validates a postal code and confirms the COUNTRY. It cannot say
   WHEN, because the timings are province level. Sharon, 1 Sept 2026:

       British Columbia .... 1 week      (V)
       Alberta ............. 2 weeks     (T)
       everywhere else ..... 3 weeks     central Canada and east

   The northern territories (X, Y) sit in the 3 week band with everything else.
   They are almost certainly slower than that; flagged rather than guessed at.

   These numbers used to drive the PRE-ORDER date too. Since 2 October 2026 a
   pre-order shows a ship window that does not depend on the province, so
   nothing here touches it (see the PRE-ORDER note in sections/rn-buybox.liquid).

   That logic lives here rather than in sections/rn-buybox.liquid because that
   file is 129KB and shared by all three PDPs.

   The delivery box is three stacked lines, styled in rn-pdp-fit.css:

       .dl-1   the promise      In Stock / <Province> and the timing
       .dl-2   the cost         Standard and White Glove flat rates
       .dl-3   the prompt       replaced by the entered postal code

   The section writes its own flat string into p.bb-zipnote, so we watch that
   element and rebuild the three-line structure whenever it changes. The guard
   comparing existing markup stops the MutationObserver re-triggering itself.
   =========================================================================== */
(function () {
  var PROVINCE = {
    A: 'Newfoundland and Labrador', B: 'Nova Scotia', C: 'Prince Edward Island',
    E: 'New Brunswick', G: 'Quebec', H: 'Quebec', J: 'Quebec',
    K: 'Ontario', L: 'Ontario', M: 'Ontario', N: 'Ontario', P: 'Ontario',
    R: 'Manitoba', S: 'Saskatchewan', T: 'Alberta', V: 'British Columbia',
    X: 'Northwest Territories and Nunavut', Y: 'Yukon'
  };
  var CA_POSTCODE = /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ][0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/;
  /* THIS LINE WAS STALE AND IT OVERWROTE THE CORRECT ONE (found 15 Sep 2026).

     Standard delivery became FREE over C$100 on 13 September, with White Glove
     a C$150 upgrade, confirmed at a real checkout. All twelve product templates
     were updated that day. This file was not — and this file WINS, because
     apply() rewrites .bb-zipnote the moment a shopper enters a postal code.

     So the live Canadian PDP showed the correct free-delivery line until the
     customer typed their postcode to check delivery, and then replaced it with
     the old C$159 / C$309 price. It broke at exactly the moment someone was
     deciding to buy, and nothing reported it.

     The string below is now verbatim what the twelve templates say. If the
     shipping rule changes again, it has to change in BOTH places - grep
     `White Glove upgrade` before editing either. */
  var COST = 'Free standard delivery over C$100 · White Glove upgrade C$150';

  /* days to the customer's door, INCLUDING the 3-5 days to pick and dispatch */
  var ZONE = { V: 7, T: 14 };
  var ZONE_DEFAULT = 21;
  function zoneDays(letter) { return ZONE[letter] || ZONE_DEFAULT; }
  function zoneWords(letter) {
    var d = zoneDays(letter);
    return d === 7  ? 'Delivery within 1 week'
         : d === 14 ? 'Delivery in up to 2 weeks'
         :            'Delivery in up to 3 weeks';
  }

  function pretty(code) { return code.slice(0, 3) + ' ' + code.slice(3); }

  function markup(code) {
    var letter = code.charAt(0);
    var province = PROVINCE[letter];
    if (!province) return null;
    var when = zoneWords(letter);
    return '<span class="dl-1">' + province + ' · ' + when + '</span>' +
           '<span class="dl-2">' + COST + '</span>' +
           '<span class="dl-3">Estimate for ' + pretty(code) + '</span>';
  }

  function apply(zip) {
    var input = zip.querySelector('input');
    var note = zip.querySelector('.bb-zipnote');
    if (!input || !note) return;
    var code = (input.value || '').replace(/[\s-]/g, '').toUpperCase();
    if (!CA_POSTCODE.test(code)) return;   // leave the section's own handling alone
    var want = markup(code);
    if (!want || note.innerHTML === want) return;
    note.innerHTML = want;
  }

  function wire(zip) {
    var run = function () {
      setTimeout(function () { apply(zip); }, 60);
      setTimeout(function () { apply(zip); }, 450);
    };
    zip.addEventListener('click', run, true);
    zip.addEventListener('change', run, true);
    zip.addEventListener('keyup', function (e) { if (e.key === 'Enter') run(); }, true);
    var note = zip.querySelector('.bb-zipnote');
    if (note && window.MutationObserver) {
      new MutationObserver(function () { apply(zip); })
        .observe(note, { childList: true, characterData: true, subtree: true });
    }
  }

  function init() {
    var zips = document.querySelectorAll('.bb-zip');
    for (var i = 0; i < zips.length; i++) wire(zips[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
